import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { setupConditionalLogging } from "./utils/logging";

setupConditionalLogging();

createRoot(document.getElementById("App")!).render(<App />);
